import React, { useState, useEffect } from "react";
import Loader from "../../components/styled-components/loader/loader";
import DEATH_API from "../../apis/death.api";
import protectedImg from "../../assets/images/DeathModuleNew/protected.svg";
import "./deathDashboard.css";
import { ToolTipCreator } from "../../helpers/ToolTipCreator";

export const BurialExpenseDashboard = (props) => {
  const [loading, setLoading] = useState(false);
  const [burialExpense, setBurialExpense] = useState(0);

  const getBurialExpense = async () => {
    try {
      setLoading(true);
      const ID = localStorage.getItem("accessId");
      let data = await DEATH_API.fetchPrepaidBurial(ID);
      if (data && data.data) {
        data.data.map((item) => {
          if (item.amount) {
            setBurialExpense(item.amount + burialExpense);
          }
        });
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  useEffect(() => {
    console.log("calling api");
    if (props.role !== "trustee") {
      getBurialExpense();
    }
  }, []);
  return (
    <div>
      {" "}
      <div className="cardHeading">
        <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
          Funeral Wishes
          <ToolTipCreator name={"Death_Funeral_Wishes"}/>
        </div>
      </div>
      {props.role !== "trustee" ? (
        <React.Fragment>
          <div
            className="cardDesc"
            style={{ marginTop: "8px", marginBottom: "8px" }}
          >
            If the Plan Creator has chosen to pay or earmark certain
            instructions relevant to their burial or ceremony, it can be found
            in this feature...
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
           {/*  <div className="payField">
              {" "}
              {burialExpense ?  `${"$" + burialExpense.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}` : "0"}
            </div>*/}
            <div className="payButtonView"> View </div>
          </div>
        </React.Fragment>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontWeight: "700",
            fontFamily: "Poppins",
            fontSize: "14px",
            marginTop:"1rem",
            flexDirection: "column",
          }}
        >
          This information will be available to you soon!
          <img
            src={protectedImg}
            style={{ width: "50px", height: "50px", marginTop: "8px" }}
            alt="protectedImg"
          ></img>
        </div>
      )}
    </div>
  );
};
